import * as React from 'react'
import { CustomFieldListItem } from './CustomFieldListItem'
import { useSelectCustomFieldData } from '@user/store/customFields'
import { TextFieldProps } from '@mui/material/TextField'

interface Props {
  hideOptional?: boolean
  avoidValidateOnBlur?: boolean
  textFieldProps?: TextFieldProps
  margin?: 'none' | 'dense' | 'normal'
}

export function CustomFieldList(props: Props) {
  const { hideOptional, textFieldProps, margin, avoidValidateOnBlur } = props
  const { customSettings, orderedCustomFields } = useSelectCustomFieldData()
  return (
    <>
      {orderedCustomFields.map((field) => (
        <CustomFieldListItem
          key={field.id}
          field={field}
          hideOptional={hideOptional}
          customSettings={customSettings}
          textFieldProps={textFieldProps}
          margin={margin}
          avoidValidateOnBlur={avoidValidateOnBlur}
        />
      ))}
    </>
  )
}
